import React from 'react';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { ButtonsRow, CleanFilter, ModalContent, SaveButton, StyledModal } from './styled';
import { MultiSelectDropdown, FilterOption } from 'newComponents/Form/Multiselect';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';

interface EnvironmentsEquipmentModalProps {
  title: string;
  setClose: (open: boolean) => void;
  areaGroupsOptions: FilterOption[];
  areaSubgroupsOptions: FilterOption[];
  areasOptions: FilterOption[];
  equipmentTypesOptions: FilterOption[];
  equipmentOptions: FilterOption[];
  areaGroupsValues: string[];
  areaSubgroupsValues: string[];
  areasValues: string[];
  equipmentTypesValues: string[];
  equipmentValues: string[];
  onAreaGroupsChange: (values: unknown) => void;
  onAreaSubgroupsChange: (values: unknown) => void;
  onAreasChange: (values: unknown) => void;
  onEquipmentTypesChange: (values: unknown) => void;
  onEquipmentChange: (values: unknown) => void;
  onFilter: () => void;
  onClearFilters: () => void;
  onLoadMoreAreas?: () => void;
  onSearchArea?: (term: string) => void;
  onLoadMoreEquipamentos?: () => void;
  onSearchEquipamento?: (term: string) => void;
}

export const EnvironmentsEquipmentModal: React.FC<EnvironmentsEquipmentModalProps> = ({
  title,
  setClose,
  areaGroupsOptions,
  areaSubgroupsOptions,
  areasOptions,
  equipmentTypesOptions,
  equipmentOptions,
  areaGroupsValues,
  areaSubgroupsValues,
  areasValues,
  equipmentTypesValues,
  equipmentValues,
  onAreaGroupsChange,
  onAreaSubgroupsChange,
  onAreasChange,
  onEquipmentTypesChange,
  onEquipmentChange,
  onFilter,
  onClearFilters,
  onLoadMoreAreas,
  onSearchArea,
  onLoadMoreEquipamentos,
  onSearchEquipamento,
}) => {
  return (
    <StyledModal title={title} setClose={setClose}>
      <ModalContent>
        <FieldRow marginBottom="20px" />
        <FormGroup label="Grupos de ambientes">
          <MultiSelectDropdown
            options={areaGroupsOptions}
            value={areaGroupsValues}
            onChange={onAreaGroupsChange}
            size="md"
            width="100%"
            placeholder="Selecione"
            clearable={true}
            top="27px"
            searchable={true}
            temSelecionarTodos={true}
            showScrollbar={true}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Subgrupos de ambientes">
          <MultiSelectDropdown
            options={areaSubgroupsOptions}
            value={areaSubgroupsValues}
            onChange={onAreaSubgroupsChange}
            size="md"
            width="100%"
            placeholder="Selecione"
            clearable={true}
            top="27px"
            searchable={true}
            temSelecionarTodos={true}
            showScrollbar={true}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Ambientes">
          <MultiSelectDropdown
            options={areasOptions}
            value={areasValues}
            onChange={onAreasChange}
            size="md"
            width="100%"
            placeholder="Selecione"
            clearable={true}
            top="27px"
            searchable={true}
            searchMode="remote"
            dataMode="infinite"
            onSearch={onSearchArea}
            onScrollEnd={onLoadMoreAreas}
            temSelecionarTodos={true}
            showScrollbar={true}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Tipo de equipamentos">
          <MultiSelectDropdown
            options={equipmentTypesOptions}
            value={equipmentTypesValues}
            onChange={onEquipmentTypesChange}
            size="md"
            width="100%"
            placeholder="Selecione"
            clearable={true}
            top="27px"
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <FormGroup label="Equipamentos">
          <MultiSelectDropdown
            options={equipmentOptions}
            value={equipmentValues}
            onChange={onEquipmentChange}
            size="md"
            width="100%"
            placeholder="Selecione"
            clearable={true}
            top="27px"
            searchable={true}
            searchMode="remote"
            dataMode="infinite"
            onSearch={onSearchEquipamento}
            onScrollEnd={onLoadMoreEquipamentos}
            temSelecionarTodos={true}
            showScrollbar={true}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />

        <ButtonsRow>
          <SaveButton onClick={onFilter}>Filtrar</SaveButton>
          <CleanFilter onClick={onClearFilters} title="Limpar filtros de Ambientes e Equipamentos">
            <XIcon />
            Limpar filtros
          </CleanFilter>
        </ButtonsRow>
      </ModalContent>
    </StyledModal>
  );
};
